const OFFLINE_MESSAGE = "You're offline. Check your internet connection and try again.";
const DEFAULT_NETWORK_MESSAGE = 'Unable to load data. Please try again.';

function isTransportError(error) {
  if (!error) return false;
  if (error.isNetworkError || error.isTransportError) return true;

  const message = String(error.message || error);
  return /failed to fetch|networkerror|network request failed|did not return json/i.test(
    message
  );
}

/** Convert transport failures to safe UI copy while preserving API messages. */
export function getUserFriendlyError(
  error,
  fallbackMessage = DEFAULT_NETWORK_MESSAGE,
  emptyMessage = fallbackMessage
) {
  if (typeof navigator !== 'undefined' && navigator.onLine === false) {
    return OFFLINE_MESSAGE;
  }

  if (isTransportError(error)) {
    return fallbackMessage;
  }

  return error?.message || emptyMessage;
}

export { OFFLINE_MESSAGE, DEFAULT_NETWORK_MESSAGE };
